




















import Vue from "vue";
import config from "@/configs";
import SnackBar from "@/components/SnackBar.vue";
import AppTranslationSelect from "@/components/AppTranslationSelect.vue";
import LogoutModalIdle from "@/components/Common/LogoutModalIdle.vue";
import { get } from "lodash";

export default Vue.extend({
  components: { SnackBar, AppTranslationSelect, LogoutModalIdle },
  mounted() {
    (this.$root as any).snackbar = this.$refs.snackbar;
    // Handle hard refresh language
    this.$i18n.locale = localStorage.getItem("lang") as string;
  },
  computed: {
    showTranslations(): boolean {
      return get(config, "settings.languages", []).length > 1;
    },
    showModalIdle(): boolean {
      return get(config, "settings.idleTime", false);
    },
  },
});
